// extracted by mini-css-extract-plugin
export default {"container":"employee_container__3fpje","blocks":"employee_blocks__eH8IZ","blockTitle":"employee_blockTitle__LbNpt","blockText":"employee_blockText__goaPe"};